import { Button } from 'primereact/button'
import { Chip } from 'primereact/chip'
import styled from 'styled-components'
export const ApprovalButtonGroup=styled.div`
    display: flex;
    gap: 10px; /* Butonlar arasındaki boşluk */
`
export const TableApproveButton = styled(Button)`
  width: ${({ width }: { width?: number; height?: number }) => `${width || 100}px`};
  height: ${({ height }: { height?: number }) => `${height || 40}px`};
  justify-content: center;
  color: #ffffff;
  background: #45bfe5;
  border-radius: 10px;
  border: 1px solid #45bfe5;
  font-weight: bold;
    :enabled:hover,
    .p-button:not(button):not(a):not(.p-disabled):hover {
        color: #ffffff;
        background: #7ccde7;
        border: 1px solid #7ccde7;
    }
`
export const TableRejectButton = styled(Button)`
  width: ${({ width }: { width?: number; height?: number }) => `${width || 100}px`};
  height: ${({ height }: { height?: number }) => `${height || 40}px`};
  justify-content: center;
  color: #45bfe5;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #45bfe5;
  font-weight: bold;
    :enabled:hover,
    .p-button:not(button):not(a):not(.p-disabled):hover {
        color: #ffffff;
        border: 1px solid #7ccde7;
    }
`
export const TableTextButton = styled(Button)`
  width: ${({ width }: { width?: number; height?: number }) => `${width || 100}px`};
  height: ${({ height }: { height?: number }) => `${height || 40}px`};
  justify-content: center;
  text-decoration: underline;
  border-radius: 10px;
  color: #363636 !important;

  :focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: none;
    background-color: none;
  }

  :disabled {
    opacity: 0.4;
  }
`

export const TableChip = styled(Chip)`
  background: rgba(173, 187, 255, 0.4);
  padding: 2px 1rem;

  .p-chip-text {
    font-weight: 700;
    font-size: 13px;
    line-height: 16px;
    text-align: center;
    color: #363636;
  }
`

export const Line = styled.span`
  font-size: 1.3rem;
  color: #9d9d9d;

  @media (max-width: 1400px) {
    display: none;
  }
`
